import request from '@/router/axios'

export function getWordsPage(params) {
    return request({
        url: '/basic/admin/words/page',
        method: 'GET',
        params: params
    })
}

export function saveWords(data) {
    return request({
        url: '/basic/admin/words',
        method: 'POST',
        data: data
    })
}

export function updateWords(data) {
    return request({
        url: '/basic/admin/words',
        method: 'PUT',
        data: data
    })
}

export function deleteWords(id) {
    return request({
        url: `/basic/admin/words/${id}`,
        method: 'DELETE'
    })
}
